import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ALERT_MESSAGES } from '../../enums/common'
import { ITextInput } from '../../interfaces/FormFields'
import { folderActions } from '../../store/slices/Folder'
import { IFolderContent } from '../../interfaces/Folder'
import { IStore } from '../../interfaces/Store'

const TextInput = ({
  id,
  name,
  className = '',
  labelClassName = '',
  inputClassName = '',
  labelBold,
  register,
  error,
  defaultValue,
  placeHolder,
  label,
  dataTestId,
  maxLength,
  onChange,
  required,
  triggerValidation,
  onBlur,
  onFocus,
}: ITextInput): ReactElement => {
  const [isInputValid, setInputValid] = useState()
  const dispatch = useDispatch()
  const folderError = useSelector(
    (state: IStore) => state.folderReducer.folderError
  )

  const checkInputValid = async () => {
    await triggerValidation(name)
    if (folderError && folderError[name as keyof IFolderContent]) {
      dispatch(
        folderActions.clearFolderError({ field: name as keyof IFolderContent })
      )
    }
    setInputValid('inputFieldValid')
  }

  useEffect(() => {
    if (error && error.type) {
      return setInputValid('errorHighlight')
    }
    if (!error && isInputValid !== undefined) {
      return setInputValid('inputFieldValid')
    }
  }, [error])
  const errorMessage =
    error?.message || error?.types?.message || ALERT_MESSAGES.mandatory.message

  return (
    <div className={`inputGroup ${className}`}>
      {label && (
        <label
          className={`inputLabel ${
            required ? 'inputLabelRequired' : ''
          } ${labelClassName} ${labelBold ? 'fontWeight700' : ''}`}
          htmlFor={id}
        >
          {label}
        </label>
      )}
      <input
        onFocus={onFocus}
        name={name || id}
        className={`inputField ${inputClassName} ${
          error ? 'errorHighlight' : isInputValid
        } `}
        id={id}
        ref={register}
        defaultValue={defaultValue || ''}
        placeholder={placeHolder}
        data-testid={dataTestId}
        maxLength={maxLength}
        onChange={(e) => {
          if (onChange) {
            onChange(e)
          }
          checkInputValid()
        }}
        onBlur={onBlur}
      />
      {error && <p className="errorError mt05">{errorMessage}</p>}
    </div>
  )
}

export default TextInput
